import styled from 'styled-components';

export const TimeStripesGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 322px);
  grid-gap: 40px;
  & > div {
    position: relative;
    width: 288px;
  }
`;

export const DeleteWrapper = styled.div`
  position: absolute;
  right: -38px;
  top: 34px;
  cursor: pointer;
`;

export const AddWrapper = styled.div`
  display: flex;
  justify-content: right;
`;
